// TODO: Move this to RSUI
import React, { useRef, useState } from 'react';
// import PropTypes from 'prop-types';

import { Button } from '@redshelf/redshelf-ui';

import {
  Box,
  Chip,
  IconButton,
  ListItem,
  Menu,
  makeStyles,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      '& + &': {
        marginLeft: theme.spacing(1),
      },
    },
    chip: {
      ...theme.typography.body2,
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      color: theme.palette.grey[900],
      '& .MuiButton-endIcon': {
        marginRight: theme.spacing(1),
      },
    },
    menu: {
      width: 256, // Note: this is arbitrary
      maxWidth: '100%',
    },
    subHeader: {
      outline: 'none',
    },
    subHeaderLabel: {
      ...theme.typography.body1,
      fontWeight: theme.typography.fontWeightMedium,
    },
  };
});

// TODO: This can probably be combined with `ActionMenu`, but specify `component` prop to render "anchor" as
// chip instead of <IconButton />. Then, wherever this is consumed can utilize `ActionMenuItem`(s)
const FilterChip = ({ children, label, ...props }) => {
  const classes = useStyles();
  const anchorRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuOpen = () => {
    setIsMenuOpen(true);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  const subHeaderLabel = React.useMemo(() => {
    return label;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className={classes.root} {...props}>
      <Chip
        component={Button}
        onClick={handleMenuOpen}
        className={classes.chip}
        ref={anchorRef}
        endIcon={<ArrowDropDownIcon />}
        variant="outlined"
        label={label}
        aria-controls={`filter-chip-${subHeaderLabel}`}
        aria-haspopup="true"
      />
      <Menu
        id={`filter-chip-${subHeaderLabel}`}
        keepMounted
        anchorEl={anchorRef.current}
        elevation={1}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        PaperProps={{ className: classes.menu }}
        getContentAnchorEl={null}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <ListItem className={classes.subHeader}>
          <span className={classes.subHeaderLabel}>{subHeaderLabel}</span>
          <Box flexGrow={1} />
          <IconButton
            size="small"
            elevation={2}
            onClick={handleMenuClose}
            aria-label={`close ${subHeaderLabel} filter`}
          >
            <CloseIcon />
          </IconButton>
        </ListItem>
        {children}
      </Menu>
    </Box>
  );
};

FilterChip.propTypes = {
  /**
   * The content of the component.
   */
  // children: PropTypes.node,
};

FilterChip.defaultProps = {};

export default FilterChip;
